import { useGetVariantContentOptions } from 'features/menu/hooks/use-get-variant-content-options';
import { excludeDisabledMenuSections } from 'features/menu/pages/main-menu-page/utils';

import { IMainMenuViewOption } from '@rbi-ctg/menu';
import { IMainMenuView } from '@rbi-ctg/menu';
import { IGetMenuSectionsQuery } from 'generated/sanity-graphql';
import { useMenuContext } from 'state/menu';
import { useDayPartSelector } from 'state/menu/main-menu/hooks/use-day-part-selector';
import { useServiceModeLive } from 'state/service-mode';
import { getTabbedMenuData, optionToUrl } from 'utils/menu';

export const useMenuSectionTabs = ({
  menuData,
}: {
  menuData: IGetMenuSectionsQuery['Menu'] | IMainMenuView | null | undefined;
}) => {
  const serviceMode = useServiceModeLive();
  const { getDayPart } = useDayPartSelector();
  const { getPricingAndAvailability, showBurgersForBreakfast, activeDayParts } = useMenuContext();
  const { currentDayPart } = getDayPart();

  const getVariantContentOptions = useGetVariantContentOptions();

  // TODO: Menu - loop 1
  const menuDataFilteredItems: IMainMenuViewOption[] =
    // @ts-expect-error TS(2349) FIXME: This expression is not callable.
    (menuData?.options?.filter(item => !(item?.__typename === 'Combo')) as IMainMenuViewOption[]) ||
    [];

  // TODO: Menu - loop 2
  const mainMenuItems = excludeDisabledMenuSections({
    menuData: menuDataFilteredItems,
    activeDayParts,
    serviceMode,
    showBurgersForBreakfast,
    getPricingAndAvailability,
  });

  // TODO: Menu - loop 3
  const menuItems = getTabbedMenuData({
    mainMenuItems,
    dayPartMenu: currentDayPart,
  });

  // TODO: Menu - loop 4
  const menuSectionTabs = menuItems.map(item => {
    const carouselImage = 'carouselImage' in item ? item.carouselImage : undefined;

    const { name } = getVariantContentOptions(item);
    const label = name?.locale ?? '';

    return {
      tabItemId: item._id,
      label,
      to: optionToUrl(item),
      carouselImage,
    };
  });

  return {
    menuSectionTabs,
  };
};
